import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import translationHelper from './TranslationHelper';

class TranslateListItem extends React.PureComponent {
  translationChanged = evt => {
    const inputName = evt.target.name;
    if (!inputName) return;
    const language = inputName.replace('value_', '');
    if (!language) return;
    const value = evt.target.value || null;
    const { onChange, onDefaultChanged, translations } = this.props;

    onChange(translationHelper.handleTranslationChanged(translations, language, value));
    if (onDefaultChanged) {
      const translation = translations.find(x => x.language === language);
      if (translation && translation.isTenantLanguage) onDefaultChanged(value);
    }
  };

  getLabelFunction = () => {
    const { label } = this.props;
    if (typeof label === 'string' && label) {
      return tr => `${label} ${tr.language}`;
    }
    if (typeof label === 'function') {
      return tr => `${label(tr)}`;
    }
    return tr => tr.language;
  };

  render() {
    const {
      labelClass,
      label,
      inputClass,
      translations,
      disabled,
      showValidation,
      maxLength,
      textarea,
      required,
    } = this.props;
    const labelFunc = this.getLabelFunction();

    return (
      <>
        {translations &&
          translations.map(tr => {
            const inputLabel = labelFunc(tr);
            return (
              <div className="form-group" key={tr.language}>
                {textarea ? (
                  <>
                    <label className="control-label col-md-12">{inputLabel}</label>
                    <div className="col-md-12">
                      <textarea
                        name={`value_${tr.language}`}
                        className={classnames('form-control', {
                          markedError:
                            (showValidation || tr.value !== tr.orgValue) &&
                            tr.isTenantLanguage &&
                            !tr.value &&
                            required,
                        })}
                        style={{ resize: 'vertical' }}
                        value={tr.value || ''}
                        onChange={this.translationChanged}
                        required={tr.isTenantLanguage}
                        disabled={disabled}
                        placeholder={inputLabel}
                        maxLength={maxLength}
                        autoComplete="off"
                        rows={7}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <label className={classnames('control-label', labelClass)}>{inputLabel}</label>
                    <div className={inputClass}>
                      <input
                        type="text"
                        name={`value_${tr.language}`}
                        className={classnames('form-control', {
                          markedError:
                            (showValidation || tr.value !== tr.orgValue) &&
                            tr.isTenantLanguage &&
                            !tr.value &&
                            required,
                        })}
                        value={tr.value || ''}
                        onChange={this.translationChanged}
                        required={tr.isTenantLanguage}
                        disabled={disabled}
                        placeholder={inputLabel}
                        maxLength={maxLength}
                        autoComplete="off"
                      />
                    </div>
                  </>
                )}
              </div>
            );
          })}
      </>
    );
  }
}

TranslateListItem.propTypes = {
  // The translations to edit, use the TranslationHelper to retrieve or create!
  translations: PropTypes.arrayOf(translationHelper.translationShape).isRequired,
  // (translations)=>{}
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  // (newValue)=>{}
  onDefaultChanged: PropTypes.func,
  // Change width of label
  labelClass: PropTypes.string,
  // If string, `${label} ${language}`
  // If func, (translation)=>{return 'string'};
  // If null, language
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  // Change width of input
  inputClass: PropTypes.string,
  // Disable inputs (when saving)
  disabled: PropTypes.bool,
  // Show validation errors (hover save button)
  showValidation: PropTypes.bool,

  maxLength: PropTypes.number,
  textarea: PropTypes.bool,
};
TranslateListItem.defaultProps = {
  labelClass: 'col-md-3',
  label: '',
  inputClass: 'col-md-6',
  disabled: false,
  showValidation: false,
  onDefaultChanged: null,
  maxLength: undefined,
  textarea: false,
  required: true,
};

export default TranslateListItem;
